import { render, staticRenderFns } from "./MenuConfiguration.vue?vue&type=template&id=0cf47c18"
import script from "./MenuConfiguration.vue?vue&type=script&lang=js"
export * from "./MenuConfiguration.vue?vue&type=script&lang=js"
import style0 from "./MenuConfiguration.vue?vue&type=style&index=0&id=0cf47c18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports